<div class="p-3">
    v{{ environmentsInformation.front.version }} -
    {{ environmentsInformation.front.name }}
    <br />
    v{{ environmentsInformation.back.version }} -
    {{ environmentsInformation.back.name }}
</div>
